import {PlayerReducer, ReducerFromState} from "../../../@types/reducers";
import {PlayerBookmakersStoredObject} from "../../../@types/response";

export const GetEventPlayers = (state: ReducerFromState<PlayerReducer>): null | PlayerBookmakersStoredObject => state.player.eventPlayers;